import React from 'react';
import useTheme from 'branding/theme';
import getIconColor from '../../getIconColor';
const MobileIcon = ({ type = 'brand', size = 'regular', styles, ...rest }) => {
    const { colors, sizing } = useTheme();
    const color = getIconColor(colors, type);
    const sizePx = sizing.widths.icon[size];
    return (React.createElement("svg", { width: sizePx, height: sizePx, viewBox: "0 0 27 41", style: styles, ...rest },
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("path", { d: "M-847-1282H593V879H-847z" }),
            React.createElement("g", { strokeWidth: "2", stroke: color, strokeLinecap: "round" },
                React.createElement("path", { d: "M25.925 7.59L5.729 7.522M5.638 28.946l-.005 6.995c-.008 2.069 1.691 3.768 3.773 3.774l12.624.042c2.082.008 3.792-1.68 3.8-3.749v-.456M5.653 28.946l.078-23.87c.008-2.07 1.717-3.757 3.8-3.751l12.623.043c2.083.008 3.78 1.706 3.774 3.775l-.067 21.068-.011 2.504" }),
                React.createElement("path", { d: "M18.244 33.735a1.898 1.898 0 01-1.902 1.891 1.899 1.899 0 01-1.891-1.904 1.895 1.895 0 011.902-1.89 1.895 1.895 0 011.891 1.903M1.8 28.788h24.049" })))));
};
export default MobileIcon;
//# sourceMappingURL=index.js.map